import { useMemo } from "react";
import { ColorMap } from "../components/dashboard/types";
import { generateColorMap } from "../utils/colorUtils";

interface UseColorMappingReturn {
  colorMap: ColorMap;
}

export const useColorMapping = <T extends Record<string, any>>(
  data: T[],
  colorBy: string
): UseColorMappingReturn => {
  const colorMap = useMemo(() => {
    if (!data || data.length === 0) return {};

    const uniqueValues = [...new Set(data.map((item) => item[colorBy]))].filter(
      Boolean
    ) as string[];

    return generateColorMap(uniqueValues, colorBy);
  }, [data, colorBy]);

  return { colorMap };
};
